export const USER_PASSWORD_STATUS = {
  DONE: 'hasPassword',
  PENDING: 'noPassword',
  ERROR: 'noUser',
};

/**
 * Maps the /users/exists answer to the login step to show.
 *
 * Only the set-password flow (passwordChangeRequired + welcomeJourneyEligible)
 * leaves the password step. Every other answer, including
 * passwordChangeRequired without welcomeJourneyEligible (afy-auth no longer
 * returns that flag), falls back to the password step so "Continue" always
 * moves forward and the member can use "Forgot Password?".
 * @param {{ passwordChangeRequired?: boolean, welcomeJourneyEligible?: boolean } | undefined} user
 * @returns {string} a USER_PASSWORD_STATUS value
 */
export const resolvePasswordStatus = (user) => {
  if (user?.passwordChangeRequired && user?.welcomeJourneyEligible) {
    return USER_PASSWORD_STATUS.PENDING;
  }
  return USER_PASSWORD_STATUS.DONE;
};

const LOGGED_IN_FLAG = 'hasLoggedInBefore';

/**
 * Checks if the user should see the first-time user message
 * @returns {boolean} true if the user has never logged in before
 */
export const shouldShowFirstTimeMessage = () => {
  try {
    const hasLoggedInBefore = localStorage.getItem(LOGGED_IN_FLAG);
    // Explicitly check for string 'true' since localStorage stores everything as strings
    return hasLoggedInBefore !== 'true';
  } catch (error) {
    // If localStorage is not available, don't show the message
    console.error('Error accessing localStorage:', error);
    return false;
  }
};

/**
 * Marks the user as having successfully logged in
 * This prevents the first-time user message from showing again
 */
export const markUserAsLoggedIn = () => {
  try {
    localStorage.setItem(LOGGED_IN_FLAG, 'true');
  } catch (error) {
    console.error('Error setting localStorage:', error);
  }
};